import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import CollapsibleHeader from '../../../layout/CollapsibleHeader';
import { numberFormatter } from '../../../../utils/number';
import UnreturnedAmountTable from './UnreturnedAmountTable';

const UnreturnedAmountSummary = ({
  salesSessionId,
  totalUnreturnedAmount,
  numberOfUnreturnedAmounts,
}) => {
  if (totalUnreturnedAmount <= 0) {
    return null;
  }

  return (
    <>
      <hr />
      <CollapsibleHeader
        headerText="Monto no Retornado"
        component={UnreturnedAmountTable}
        salesSessionId={salesSessionId}
      />
      <Row>
        <Col>
          <ResourceProperty label="Cantidad: " boldLabel={false}>
            {numberOfUnreturnedAmounts}
          </ResourceProperty>
          <ResourceProperty label="Total de Monto no Retornado: ">
            {numberFormatter({ value: totalUnreturnedAmount })}
          </ResourceProperty>
        </Col>
      </Row>
    </>
  );
};

UnreturnedAmountSummary.propTypes = {
  salesSessionId: PropTypes.number.isRequired,
  totalUnreturnedAmount: PropTypes.number.isRequired,
  numberOfUnreturnedAmounts: PropTypes.number.isRequired,
};

export default UnreturnedAmountSummary;
